import {LoadPhotoswipe} from './load-photoswipe';

const attributes = {
  videoPlay: 'data-video-play',
};

class VideoPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.videoPlay = this.querySelectorAll(`[${attributes.videoPlay}]`);

    this.videoPlay?.forEach((button) => {
      button.addEventListener('click', (e) => {
        const button = e.currentTarget;
        if (button.getAttribute(attributes.videoPlay).trim() !== '') {
          e.preventDefault();

          const items = [
            {
              html: button.getAttribute(attributes.videoPlay),
            },
          ];

          new LoadPhotoswipe(items);
          window.accessibility.lastElement = button;
        }
      });
    });
  }
}

export {VideoPopup};
